import * as React from 'react';
import BaseChart from '../BaseChart';
import useHighcharts from '../UseHighcharts';
import { jsx as _jsx } from "react/jsx-runtime";
const HighchartsChart = props => {
  const Highcharts = useHighcharts();
  return /*#__PURE__*/_jsx(BaseChart, {
    ...props,
    chartCreationFunc: Highcharts.chart,
    chartType: "chart"
  });
};
export default HighchartsChart;